/* tslint:disable */
/* eslint-disable */
export enum FinanceProviderType {
  None = 'None',
  Thorn = 'Thorn',
  ThornV2 = 'ThornV2',
  FinanceNow = 'FinanceNow',
  Avanti = 'Avanti',
  Credisense = 'Credisense'
}
